import { render, staticRenderFns } from "./RegisterSelector.vue?vue&type=template&id=f328e16c"
import script from "./RegisterSelector.vue?vue&type=script&lang=ts"
export * from "./RegisterSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports